<template>
  <!-- <div class="app" v-if="true"> -->
  <div class="app" v-if="show">
    <Header></Header>
    <div class="main">
      <component :is="mainshow"></component>
    </div>
    <!-- <Footer :resData="pagedata.footer"></Footer> -->
  </div>
</template>

<script>
import Header from "../../components/header.vue";
import Footer from "../../components/footer.vue";
import index from "../../components/top.vue";
import news from "../../components/news.vue";
import newDetails from "../../components/newDetails.vue";
import company from "../../components/company.vue";
import product from "../../components/product.vue";
import privacy from "../../components/privacy.vue";
export default {
  data() {
    return {
      languages: "",
      allData: "",
      pagedata: "",
      mainshow: "index",
      show: false,
    };
  },
  components: {
    Header,
    Footer,
    index,
    news,
    company,
    newDetails,
    product,
    privacy,
  },
  watch: {
    $route(to, from) {
      this.mainshow = this.$route.name;
    },
  },
  created() {
    // console.log(this.mainshow);
  },
  methods: {
    mainfun(type) {
      this.mainshow = type;
    },
    languagefun(val) {
      this.$cookieStore.addCookie("languages", val, 1);
      this.pagedata = this.allData[val];
    },
    async getlan() {
      await this.$store.dispatch("getlanguageData");
      if (
        this.$cookieStore.getCookie("languages") &&
        this.$cookieStore.getCookie("languages") != undefined
      ) {
        this.languages = this.$cookieStore.getCookie("languages");
        this.$store.commit("changeLanguage", this.languages);
      }
      // this.axios.get('./static/language.json').then(res => {
      //     this.allData=res.data.data;
      //     this.pagedata=res.data.data[this.languages];
      // })
      this.allData = this.$store.state.allData;
      this.pagedata = this.$store.state.languagesData;
      this.show = true;
    },
  },
  mounted() {
    this.mainshow = this.$route.name;
    this.getlan();
  },
};
</script>

<style scoped>
.main {
  background-color: #f7f7f7;
  /* min-height: calc(100% - 331px); */
}
@media screen and (max-width: 1000px) {
  .app {
    margin: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .main {
    /* min-height: calc(100vh - 247px); */
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue